import { api, startLoading, endLoading } from '@/api'
import router from '@/router'
import * as types from './types'

export default {
  /**
   * Authenticate user's credential
   * @param {Object} params - User's email address and password as `{ email: null, password: null}`
   */
  async authUser({ commit, dispatch }, params) {
    let loaderName = 'authUser'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .authUser(params)
        .then(response => {
          // Set token to localStorage
          localStorage.token = response.data.token.access_token

          // Set location logo in localStorage
          let location = response.data.location
          if (location.logo !== null) {
            localStorage.locationLogo =
              'data:' + location.logoContentType + ';base64,' + location.logo
          }

          // User loggedUser vuex model
          commit(types.SET_USER)

          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch(error => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
   * Request new password
   * @param {String} email - User's email address
   */
  async requestPasswordReset({ commit, dispatch }, email) {
    let loaderName = 'requestPasswordReset'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .requestPasswordReset({ email: email })
        .then(response => {
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch(error => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
   * Set new password
   * @param {Object} user - User object with email and password
   */
  async setNewPassword({ commit, dispatch }, user) {
    let loaderName = 'setNewPassword'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .setNewPassword(user)
        .then(response => {
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch(error => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
   * This function is used everytime the route changes, to validad the user is authenticated.
   */
  checkAuth({ commit }) {
    commit(types.SET_USER)
  },
  /**
   * Log out user
   */
  logOut({ commit }) {
    commit(types.LOGOUT)
    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js